import { useDispatch, useSelector } from "react-redux";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import accountOverviewPagesService from "../../../../account-overview/shared/services/pages/accountOverviewPagesService";
import { toggleRecommendationsBarAction } from "../../../store/action-creators";
import { dismissRecommendationThunk, fetchListRecommendationsThunk } from "../../../store/effects";
import {
    selectListRecommendations,
    selectListRecommendationsFetching,
    selectListRecommendationsOpen,
} from "../../../store/selectors";
import type { OpportunityListType } from "../../../types";

import RecommendationsSidebar from "./RecommendationsSidebar";

type Props = {
    list: Readonly<OpportunityListType>;
    onAddRecommendationToList: (list: OpportunityListType, domains: readonly string[]) => void;
};

const StaticListRecommendationsSidebarContainer = ({ list, onAddRecommendationToList }: Props) => {
    const dispatch = useDispatch();

    const recommendations = useSelector(selectListRecommendations);
    const recommendationsBarOpen = useSelector(selectListRecommendationsOpen);
    const recommendationsFetching = useSelector(selectListRecommendationsFetching);

    function fetchRecommendations(id: OpportunityListType["opportunityListId"]) {
        void dispatch(fetchListRecommendationsThunk(id));
    }

    function dismissRecommendation(id: OpportunityListType["opportunityListId"], domain: string) {
        void dispatch(dismissRecommendationThunk(id, domain));
    }

    function toggleRecommendationsBar(isOpen: boolean) {
        void dispatch(toggleRecommendationsBarAction(isOpen));
    }

    function navigateToAccountOverview<P extends { key: string }>(params: P) {
        void proNavigator.go(accountOverviewPagesService.getPageStateKey("company"), params);
    }

    return (
        <RecommendationsSidebar
            list={list}
            recommendations={recommendations}
            recommendationsBarOpen={recommendationsBarOpen}
            recommendationsFetching={recommendationsFetching}
            toggleRecommendationsBar={toggleRecommendationsBar}
            addRecommendationsToList={onAddRecommendationToList}
            fetchListRecommendations={fetchRecommendations}
            dismissRecommendation={dismissRecommendation}
            onNavigateToAnalysisClick={navigateToAccountOverview}
        />
    );
};

export default StaticListRecommendationsSidebarContainer;
